import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=2fa8dd78&scoped=true&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=2fa8dd78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8dd78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
